<template>
  <v-dialog
    v-if="getVenda.id"
    v-model="getModalEnviarNfeEmail"
    max-width="720px"
    transition="dialog-transition"
  >
    <v-card outlined>
      <v-card-title>Enviar nota por e-mail</v-card-title>
      <v-form class="px-5" ref="formEnviarNfe">
        <v-card-text>
          <v-layout row wrap>
            <v-text-field
              label="E-mail"
              v-model="getVenda.cliente.email"
              outlined
              dense
              type="email"
              :rules="rules.email"
            ></v-text-field>
          </v-layout>
        </v-card-text>
      </v-form>

      <v-card-actions>
        <v-btn
          color="default"
          outlined
          dense
          @click="setModalEnviarNfeEmail(false)"
          :loading="$store.getters.getOverlay"
          >Fechar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          @click="_enviarNfeEmail()"
          outlined
          dense
          :loading="$store.getters.getOverlay"
          >Enviar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      rules: {
        email: [
          (v) => !!v || "Campo obrigatório.",
          (v) => /.+@.+/.test(v) || "E-mail inválido.",
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["getModalEnviarNfeEmail", "getVenda"]),
  },
  methods: {
    ...mapActions(["setModalEnviarNfeEmail", "enviarNfeEmail"]),
    _enviarNfeEmail() {
      this.enviarNfeEmail({
        email: this.getVenda.cliente.email,
        tipo: "NF-e",
        venda_id: this.getVenda.id,
      });
    },
  },
};
</script>
